import React from 'react';

export default function AttributionFooter() {
  return (
    <div className="mt-6 flex items-center justify-center text-xs text-gray-500">
      <span>Some data provided by Google Places. © Google.</span>
    </div>
  );
}
